import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "tagsQuestion", "standardConfirm"];
  static values = {
    bookId: String,
    removePath: String
  }

  connect() {
    // Store the book info when clicking remove
    this.hasTags = false;
  }

  checkAndRemove(event) {
    event.preventDefault();

    const bookId = event.currentTarget.dataset.bookId;
    const removePath = event.currentTarget.dataset.removePath;

    this.bookIdValue = bookId;
    this.removePathValue = removePath;

    const url = `/books/${bookId}/check_tags`;

    fetch(url)
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.has_tags) {
          this.showTagsModal();
        } else {
          this.showStandardConfirm();
        }
      })
      .catch(error => {
        this.showStandardConfirm();
      });
  }

  showTagsModal() {
    this.tagsQuestionTarget.classList.remove("hidden");
    this.standardConfirmTarget.classList.add("hidden");
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add('overflow-hidden');
  }

  showStandardConfirm() {
    this.standardConfirmTarget.classList.remove("hidden");
    this.tagsQuestionTarget.classList.add("hidden");
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add('overflow-hidden');
  }

  closeModal() {
    const bookId = this.bookIdValue;
    $(`.expand-dropdown-button[data-book-id="${bookId}"]`).removeAttr('disabled');
    $(`.read-status-dropdown-content[data-book-id="${bookId}"]`).css('display', '');
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove('overflow-hidden');
  }

  removeWithTags() {
    this.submitRemoval(true);
  }

  removeWithoutTags() {
    this.submitRemoval(false);
  }

  confirmStandardRemove() {
    this.submitRemoval(true); // No tags exist, but pass true for consistency
  }

  submitRemoval(removeTags) {
    this.closeModal();

    const separator = this.removePathValue.includes('?') ? '&' : '?';
    const url = `${this.removePathValue}${separator}remove_tags=${removeTags}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (response.ok) {
          return response.text();
        }
        throw new Error('Network response was not ok.');
      })
      .then(js => {
        eval(js);
      })
      .catch(error => {
        console.error('Error removing book:', error);
      });
  }

  // Close modal when clicking outside
  closeOnOutsideClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal();
    }
  }

  // Close on escape key
  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.closeModal();
    }
  }
}
